import { api } from '@/api';

export interface OverviewStats {
  avgMonthlyIncome: number;
  avgMonthlySpending: number;
  savingRate: number;
  categoryMap: Record<string, number>;
  merchantMap: Record<string, { amount: number; count: number }>;
  monthlyIncomeOutcomeMap: {
    month: string;
    income: number;
    spending: number;
  }[];
  uncategorizedAmount?: number;
}

/**
 * Service for fetching statistics and analytics data
 */
class StatsService {
  /**
   * Get overview statistics for the dashboard
   */
  async getOverviewStats() {
    return api.v1.stats.overview.get();
  }

  async getUncategorizedCount() {
    return api.v1.stats['uncategorized-count'].get();
  }
}

export const statsService = new StatsService();
